module.exports = __webpack_public_path__ + "img/znbw.a206fb06.png";